import script from "./ReplaceWareConfirm.vue?vue&type=script&setup=true&lang=ts"
export * from "./ReplaceWareConfirm.vue?vue&type=script&setup=true&lang=ts"

import "./ReplaceWareConfirm.vue?vue&type=style&index=0&id=517b49e3&lang=scss"

const __exports__ = script;

export default __exports__